import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from 'react-router-dom';

import { formatPrice, getBaseUrl, getMazdaFeesAndLeviesDetailTitle, convertKM, convertNum, getLang, getProvince, getDisplayableProvinceName } from '../../../utils';

import { openModal } from '../../../Helpers/helpers';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';

import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';
import { Button } from '../../1_Atoms/Button/Button';
import { CollapseList } from '../../2_Molecules/Collapse/CollapseList';
import { OcaModal } from '../../3_Organisms/Modal/OcaModal';
import { ReserveModal } from '../../3_Organisms/Modal/ReserveModal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';

export const Financial = ({
    openCollapsable,
    setOpenCollapsable,
    ...props }) => {

    const gtmHelper = new GTMHelper();
    
    const { year, carline, trim, model, packageCode } = useParams();

    const { t, i18n } = useTranslation(['summary', 'payments', 'general']);
    
    const [reserveOpen, setReserveModalOpen] = React.useState(false);
    const [preorderOpen, setPreorderModalOpen] = React.useState(false);

    const [ocaOpen, setOcaModalOpen] = React.useState(false);
    const [financeType, setFinanceType] = React.useState(false);
    const [getLocalOpen, setGetLocalOpen] = React.useState(false);

    let payment = sessionStorage.getItem(Constants.UrlSlugObjectPayments);
    let pathToPayment = '';

    if(payment) {
        payment = JSON.parse(payment);
        pathToPayment = '/'+payment.year+'/'+payment.carline+'/'+payment.trim+'/'+payment.model+'/'+payment.packageCode+'/payments?prov_code='+getProvince();
    } else {
        pathToPayment = '/'+year+'/'+carline+'/'+trim+'/'+model+'/'+packageCode+'/payments?prov_code='+getProvince();
    }

    const navigate = useNavigate();
    const [summaryCalculator = new SummaryCalculator().reloadStoredData(), setSummaryCalculator] = React.useState();
    const [feesChecked, setFeesChecked] = React.useState(summaryCalculator.IncludeFees);
    const [taxesChecked, setTaxesChecked] = React.useState(summaryCalculator.IncludeTaxes);
    const [rebatesChecked, setRebatesChecked] = React.useState(summaryCalculator.IncludeRebates);
    const [dataDisplayed, setDataDisplayed] = React.useState(false);
    const [selectedBox, setSelectedBox] = React.useState(null);

    const [financeTermIndex, setFinanceTermIndex] = React.useState(0);
    const [leaseTermIndex, setLeaseTermIndex] = React.useState(0);

    const financeTerm = summaryCalculator.FinanceTerm ? summaryCalculator.FinanceTerm  : summaryCalculator.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].term;
    const leaseTerm = summaryCalculator.LeaseTerm ? summaryCalculator.LeaseTerm: summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term;
    const currentIncentives = summaryCalculator.FinancialInfo.incentive_programs.find(element => element.type === "incentive");

    const inclusionCheck = async (event) => {
        if(event.target.id === 'fees') {
            summaryCalculator.IncludeFees = !summaryCalculator.IncludeFees;
            await summaryCalculator.RecalculateFinancialInfo();
            setFeesChecked(!feesChecked);

            gtmHelper.setGTM({'action':'Checkbox', 'type': 'Include fees', 'value': feesChecked}, true , false);
        }
        if(event.target.id === 'taxes') {
            summaryCalculator.IncludeTaxes = !summaryCalculator.IncludeTaxes;
            await summaryCalculator.RecalculateFinancialInfo();
            setTaxesChecked(!taxesChecked)

            gtmHelper.setGTM({'action':'Checkbox', 'type': 'Include taxes', 'value': taxesChecked}, true , false);
        }
        if(event.target.id === 'rebates') {
            summaryCalculator.IncludeRebates = !summaryCalculator.IncludeRebates;
            await summaryCalculator.RecalculateFinancialInfo();
            setRebatesChecked(!rebatesChecked);
            
            gtmHelper.setGTM({'action':'Checkbox', 'type': 'Include rebate', 'value': rebatesChecked}, true , false);
        }
    }

    const Obj = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));

    const handleEditFinanceLinkClick = (e) => {
        e.preventDefault();

        navigate(pathToPayment);
    }

    const handleEditLeaseLinkClick = (e) => {
        e.preventDefault();

        navigate(pathToPayment);
    }

    function getOptionList() {
        let optionList = '';
        
        const options = summaryCalculator.FinancialInfo ?.calculatedFinance ?.options;

        if(options.exteriorColour.price >0){
            optionList += ` <li >
                <p>${t('payments:exterior')} <span>${options.exteriorColour.description}</span></p>
                <span>${formatPrice(options.exteriorColour.price, true)}</span>
            </li>`
        }
        if(options ?.interiorColour.price >0){
            optionList += ` <li>
                <p>${t('payments:interior')} <span>${options.interiorColour.description}</span></p>
                <span>${formatPrice(options.interiorColour.price, true)}</span>
            </li>`
        }
        if(options ?.model_option_package ?.financial ?.msrp >0){
            optionList += ` <li>
                <p>${t('payments:package')} <span>${options.model_option_package.name}</span></p>
                <span>${formatPrice(options.model_option_package.financial.msrp, true)}</span>
            </li>`
        }

        /*const selectedWarrantyPackage = JSON.parse(sessionStorage.getItem('selectedWarrantyPackage'));
        if(selectedWarrantyPackage != null && selectedWarrantyPackage.name != undefined ){
            const warrantyPrice = (JSON.parse(sessionStorage.getItem('selectedWarrantyPackage')).financial.msrp);
            optionList += ` <li>
                <p>${t("payments:warranties")} <span>${selectedWarrantyPackage.name}</span></p>
                <span>${formatPrice(warrantyPrice, true)}</span>
            </li>`
        }   
        
        const selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage'));
        if(selectedConnectedVehiclePackage != null && selectedConnectedVehiclePackage.title != undefined){
            const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);
            optionList += ` <li>
                <p>${t("payments:connected")} <span style="text-transform:lowercase">${selectedConnectedVehiclePackage.title}</span></p>
                <span>${formatPrice(connectedPrice, true)}</span>
            </li>`
        }

        const selectedAddedProtectionPackage = summaryCalculator.SelectedAddedProtectionPackage;
        if(selectedAddedProtectionPackage && selectedAddedProtectionPackage.name){
            const selectedAddedProtectionPackagePrice = selectedAddedProtectionPackage.financial.msrp;
            optionList += ` <li>
                <p class="desc">${t("payments:added_protection")} <span style="text-transform:lowercase"> ${selectedAddedProtectionPackage.name}</span></p>
                <span class="price">${formatPrice(selectedAddedProtectionPackagePrice, true)}</span>
            </li>`
        }        

        const appearanceProtectionPlan = summaryCalculator.SelectedAppearanceProtectionPlan;
        const selectedAppearanceProtectionPlansPackage = summaryCalculator.SelectedAppearanceProtectionPlansPackage; JSON.parse(sessionStorage.getItem('selectedAppearanceProtectionPlansPackage'));
        if(appearanceProtectionPlan.name && selectedAppearanceProtectionPlansPackage.name){
            const selectedAppearanceProtectionPlansPackagePrice = selectedAppearanceProtectionPlansPackage.financial.msrp;
            optionList += ` <li>
                <p class="desc">${t("payments:appearance_protection")} <span style="text-transform:lowercase">${appearanceProtectionPlan.name} ${selectedAppearanceProtectionPlansPackage.name}</span></p>
                <span class="price">${formatPrice(selectedAppearanceProtectionPlansPackagePrice, true)}</span>
            </li>`
        }


        if(options.wheels.price >0){
            optionList += ` <li>
                <p><span>${options.wheels.title}</span></p>
                <span>${formatPrice(options.wheels.price, true)}</span>
            </li>`
        }*/

        return optionList;
    }
        
    function getMazdaPriceDetails() {
        // TODO : CHECK IF WEED ANYTHING - TO WILL FROM VIET
        //<li><p>${t("payments:accessories")}${t("payments:accLegal")}</p><span>${formatPrice(summaryCalculator.FinancialInfo.calculatedCash.accessories.total, true)}</span></li>
        return `<ul>
                    <li><p>${getMazdaFeesAndLeviesDetailTitle("Administration Fee", t)}<sup>9</sup></p><span>${formatPrice(summaryCalculator.FinancialInfo.adminServiceFees, true)}</span></li>
                    <li><p>${t("payments:msrp")}</p><span>${formatPrice(summaryCalculator.SelectedModel.financial.msrp, true)}</span></li>
                    ${getOptionList()}
                    <li><p>${t("payments:freight")}</p><span>${formatPrice(summaryCalculator.FinancialInfo.freight, true)}</span></li>
                    <li><p>${t("general:pde")}</p><span>${formatPrice(summaryCalculator.FinancialInfo.pde, true)}</span></li>
                </ul>`;
    }

    function getWheelsDetails() {
        const options = summaryCalculator.FinancialInfo ?.calculatedFinance ?.options;

        return `<ul>
                    <li><p>${`4x ${options.wheels.title}`}</p><span>${formatPrice(options.wheels.base_msrp, true)}</span></li>
                    <li><p>${`4x ${t("payments:tpms")}`}</p><span>${formatPrice(options.wheels.tpms, true)}</span></li>
                    <li><p>${t("payments:installation")}</p><span>${formatPrice(options.wheels.install_cost, true)}</span></li>
                </ul>`;
    }

    function getConnectivityDetails() {
        const selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage'));
        if(selectedConnectedVehiclePackage != null && selectedConnectedVehiclePackage.title != undefined){
            const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);

            return `<ul>
                        <li><p>${`${selectedConnectedVehiclePackage.title}`}</p><span>${formatPrice(connectedPrice, true)}</span></li>
                    </ul>`;
        }

        return '';
    }
    
    function getAccessoriesDetails() {
        let accessories = sessionStorage.getItem(Constants.SelectedAccessories);
        accessories = JSON.parse(accessories);        
    
        let list = "<ul>";
        //console.log(accessories);
        accessories.map((accessory, index) => {
            list += `<li class="financial_accessories"><p>${accessory.name}</p><span>${formatPrice(accessory.base_msrp, true)}</span></li>`
            list += `<li class="financial_accessories"><p>${accessory.name} - Installation</p><span>${formatPrice(accessory.install_cost, true)}</span></li>`
        });
        list += "</ul>"
        return list;
    }

    function getProtectionDetails() {
        let list = "<ul>";        

        if(summaryCalculator.SelectedAddedProtectionPackage.name != undefined ){
            list += `<li><p>${t("payments:added_protection")} <span>${summaryCalculator.SelectedAddedProtectionPackage.name}</span></p><span>${formatPrice(summaryCalculator.SelectedAddedProtectionPackage.financial.msrp, true)}</span></li>`
        }
        if(summaryCalculator.SelectedAppearanceProtectionPlan.name != undefined && summaryCalculator.SelectedAppearanceProtectionPlansIndex !== null) {

            list += `<li><p>${t("payments:appearance_protection")} <span>${summaryCalculator.SelectedAppearanceProtectionPlansPackage.name} for ${summaryCalculator.SelectedAppearanceProtectionPlan.name}</span></p><span>${formatPrice(summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp, true)}</span></li>`
        }     

        list += "</ul>"
        return list;
    }

    function getMazdaFeesAndLeviesDetails() {
        const feesAndLeviesToDisplay = summaryCalculator.FinancialInfo.calculatedCash.feesAndLevies.detail.filter(item => item.title !== 'PDE');

        return `<ul>
                    ${feesAndLeviesToDisplay.map((fee, index) => `<li key="${index}">
                        <p>${getMazdaFeesAndLeviesDetailTitle(fee.title, t)}${fee.sup ? `<sup>${fee.sup}</sup>` : ''}</p><span>${formatPrice(fee.price, true)}</span>
                        </li>`).join("")}
                </ul>`;
    }

    function getMazdaFeesAndLeviesPricingWithoutPDE() {
        const total = summaryCalculator.FinancialInfo.calculatedCash.feesAndLevies.detail.filter(item => item.title !== 'PDE').reduce((total, fee) => total + fee.price, 0);
        return total;
    }

    function getMazdaPrice() {
        return summaryCalculator.FinancialInfo.calculatedCash.mazdaPrice;
    }

    function getWheelsPrice() {
        const options = summaryCalculator.FinancialInfo ?.calculatedCash ?.options;

        return options.wheels.price;
    }

    function getConnectivityPrice() {
        const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);

        return connectedPrice;
    }

    function getAccessoriesPrice() {
        const accessories = summaryCalculator.FinancialInfo ?.calculatedCash ?.accessories;

        return accessories.total;
    }
    
    function getProtectionPrice() {
        const protectionPrice = summaryCalculator.SelectedAddedProtectionPackage.financial.msrp + summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp;
            
        return protectionPrice;
    }   

	function getRebatesDetails() {
        return `<ul>
                    ${summaryCalculator.FinancialInfo.calculatedCash.evRebates.details.map((rebate, index) => `<li key="${index}">
                        	<p class="text--green">${rebate.title==='federal'? t('payments:fed_rebate'):t('payments:prov_rebate') + ' ('+getProvince()+')'}</p><span class="text--green">-${formatPrice(rebate.cash, true)}</span>
                        </li>`).join("")}
                </ul>`;
    }

    function getCreditsDetails() {
        const currentIncentives = summaryCalculator.FinancialInfo.incentive_programs.find(element => element.type === "incentive");
        return `<ul class="negative">
                    ${Obj.calculatedCash.incentives.taxable.details.map((incentive, index) => {
                        const price = incentive.cash_value ? incentive.cash_value : incentive.value;
                            return `<li key="${index}">
                                    <p>${getIncentiveDisplayName(incentive)}</p><span>-${formatPrice(price, true)}</span>
                                </li>`;
                        }).join("")}
                    ${Obj.calculatedCash.incentives.nonTaxable.details.map((incentive, index) => {
                        const price = incentive.cash_value ? incentive.cash_value : incentive.value;
                            return `<li key="${index}">
                                    <p>${getIncentiveDisplayName(incentive)}</p><span>-${formatPrice(price, true)}</span>
                                </li>`;
                        }).join("")}
                    ${currentIncentives && currentIncentives.value > 0 ? `<li>
                        <p>${t("payments:current_incentives")}</p>
                        <span>${currentIncentives?'-':''}${formatPrice(currentIncentives.value, true)}</span>
                    </li>`:''}
                    ${(summaryCalculator.FinancialInfo.mazdaCashIncentive > 0) ? `<li>
                    <p>${t("payments:mazda_cash_incentive")}</p>
                    <span style="white-space: nowrap;">${summaryCalculator.FinancialInfo.mazdaCashIncentive?'-':''}${formatPrice(summaryCalculator.FinancialInfo.mazdaCashIncentive, true)}</span>
                    </li>`:''}
                    <li>
                        <p>${t("payments:trade_in")}<sup>1</sup></p><span>${Obj.tradeInValue>0?'-':''}${formatPrice(Obj.tradeInValue, true)}</span>
                    </li>
                </ul>`;
    }

    function getIncentiveDisplayName(incentive) {
        switch(incentive.type) {
            case "loyalty" :
                return t("payments:mazda_owner_loyalty_program");
            case "military":
                return t("payments:mazda_military_program");
            case "grad_award":
                return t("payments:mazda_graduate_program_award");
            case "first_time_owner":
                return t("payments:mazda_first_time_owner");
            default:
                return incentive.type;
        }
    }

    function getAnnualMileageText() {
        let mileage = '';
        switch (parseInt(summaryCalculator.AnnualMileage)) {
            case 2:
                mileage = 20000;
                break;
            case 3:
                mileage = 16000;
                break;
            case 0:
                mileage = 24000;
                break;
            default:
                break;
        }

        return `${convertKM(mileage)}/${t('year')}`;
    }


    async function handleReserveYoursClick(PurchaseMethod) {
        const isRetailerMode = await summaryCalculator.isRetailerMode();
        summaryCalculator.CurrentPurchaseMethod = PurchaseMethod;
        if (isRetailerMode) {
                setReserveModalOpen(true);
        } else {
            openGetLocal();
        }
    }

    function handlePreOrderClick() {
        document.querySelector('body').classList.add('disabled');
        setPreorderModalOpen(true);
    }


    function openGetLocal(){
        const lang = getLang();
        gtmHelper.setGTM({'action':'Open Modal','modal': 'Contact Dealer'}, true, false);

        const targetModal = document.getElementById('mz-react-send-build-to-dealer-modal');
        if (targetModal && summaryCalculator) {
            if (summaryCalculator.SelectedColourExteriorIndex !== 'null' && summaryCalculator.Colours !== null) {
                const heading = targetModal.querySelector('.mz-send-build-to-dealer__vehicle-name');
                if (heading) {
                    heading.textContent = lang === 'en' ? summaryCalculator._selectedModelYear.year.title + ' ' + ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) : ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) + ' ' + summaryCalculator._selectedModelYear.year.title;
                }
            }
            openModal('mz-react-send-build-to-dealer-modal');
        }
    }

    function financeClick(financeType){
        document.querySelector('body').classList.add('disabled');
		setOcaModalOpen(true);
        setFinanceType(financeType);

        const price = financeType === 'loan' ? summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebatesTaxed : summaryCalculator.FinancialInfo.calculatedLease.balanceToLeaseWithFeesWithRebatesTaxed;
        gtmHelper.setGTM({'action':`OCA - ${financeType === 'loan' ? 'Finance': 'Lease'} Summary`,'year': year,'model': ReactHtmlParser(carline), 'trim': trim, 'price' : Math.round(price)}, true, false);
    }

    function getLoanInformationalApr() {
        return summaryCalculator.getResponsesHasError() ? '-' : convertNum(summaryCalculator.getLoanInformationalAprRate(),2) + '%'
    }

    function getLeaseInformationalApr() {
        return summaryCalculator.getResponsesHasError() ? '-' : convertNum(summaryCalculator.getLeaseInformationalAprRate(),2) + '%'
    }

    function hasLoanRatePercentageDiscount(financeElement) {
        return (Number.parseFloat(financeElement.aprRate) !== Number.parseFloat(financeElement.aprRateDiscounted));
    }

    function getLoanRate() {
        const financeElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex];

        if (summaryCalculator.getResponsesHasError() === true)
            return '-';    
        else {
            if (hasLoanRatePercentageDiscount(financeElement))
                return convertNum(financeElement.aprRateDiscounted,2) + '%'
            else
                return convertNum(financeElement.aprRate,2) + '%'
        }         
    }

    function hasLeaseRatePercentageDiscount(leaseElement) {
        return (Number.parseFloat(leaseElement.leaseRate) !== Number.parseFloat(leaseElement.leaseRateDiscounted));
    }
        
    function getLeaseRate() {
        //return summaryCalculator.getResponsesHasError() ? '-' : convertNum(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate,2) + '%';
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex];

        if (summaryCalculator.getResponsesHasError() === true)
            return '-';        
        else {
            if (hasLeaseRatePercentageDiscount(leaseElement))
                return convertNum(leaseElement.leaseRateDiscounted,2) + '%'
            else
                return convertNum(leaseElement.leaseRate,2) + '%'
        }        
    }

    function getLoanWeekly() {
        const financeElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[financeTermIndex];

        return summaryCalculator.getResponsesHasError() ? '-' : formatPrice(financeElement[summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']);
    }

    function getLoanBiWeekly() {
        const financeElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[financeTermIndex];
        
        return summaryCalculator.getResponsesHasError() ? '-' : formatPrice(financeElement[summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly']);
    }

    function getLoanMonthly() {
        const financeElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[financeTermIndex];

        return summaryCalculator.getResponsesHasError() ? '-' : formatPrice(financeElement[summaryCalculator.IncludeTaxes ? 'monthlyWithTaxes' : 'monthly']);
    }

    function getLeaseWeekly() {
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[leaseTermIndex];

        return summaryCalculator.getResponsesHasError() ? '-': formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']);
    }

    function getLeaseBiWeekly() {
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[leaseTermIndex];
        
        return summaryCalculator.getResponsesHasError() ? '-' : formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly']);
    }

    function getLeaseMonthly() {
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[leaseTermIndex];

        return summaryCalculator.getResponsesHasError() ? '-' : formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'monthlyWithTaxes' : 'monthly']);
    }
    
    React.useEffect(() => {
        setSelectedBox(null);
        if(feesChecked) {
            setSelectedBox('feesCheck');
        }
        if(taxesChecked) {
            setSelectedBox('taxesCheck');
        }
        if(rebatesChecked) {
            setSelectedBox('rebatesCheck');
        }
        if(feesChecked && taxesChecked) {
            setSelectedBox('feestaxes');
        }
        if(feesChecked && rebatesChecked) {
            setSelectedBox('feesrebates');
        }
        if(taxesChecked && rebatesChecked) {
            setSelectedBox('taxesrebates');
        }
        if(feesChecked && taxesChecked && rebatesChecked) {
            setSelectedBox('allCheck');
        }
        
        async function executeTask() {
            await summaryCalculator.RecalculateFinancialInfo();
            setFinanceTermIndex(summaryCalculator.FinancialInfo.calculatedFinance.financeValues.findIndex(x => x.term === financeTerm));
            setLeaseTermIndex(summaryCalculator.FinancialInfo.calculatedLease.leaseValues.findIndex(x => x.term === leaseTerm));

            document.addEventListener('click',handleContactDealerLinkClick);
        }
        window.addEventListener("message", function (e) { 
            if (e.data.type === "formEvent") {
               if(e.data.origin==='form'){
    
                    // If the message 'generic' is passed, return & fire generic callback
                    if (e.data.message === "open") {
                        setReserveModalOpen(true);
                    }
               }else if(e.data.origin === 'getLocalPrice'){
                    if (e.data.message === "open") {
                        openGetLocal();
                    }
               }else if(e.data.origin === 'preOrder'){
                    sessionStorage.setItem('preorder',  e.data.message.dealer_code);
                    handlePreOrderClick();
               }

            }
        });
        
        executeTask();        
    }, [feesChecked, taxesChecked, dataDisplayed, selectedBox, rebatesChecked])


     /* START HORRIBLE HACK */
    /* TODO : MOVE TRANSLATION TEXT IN RESOURCE FILE AND MAKE A GENERIC FUNCTION FOR THE SPECIALITY "WORD" */
    function isEnglish() {
        return getLang() === 'en';
    }
    
    function getDisplayableProvinceName() {
        const provinceCode = getProvince().toLowerCase();
        const provinceNames = {
            'on': { en: 'Ontario', fr: 'en Ontario' },
            'qc': { en: 'Quebec', fr: 'au Québec' },
            'ab': { en: 'Alberta', fr: 'en Alberta' },
            'bc': { en: 'British Columbia', fr: 'au Colombie Britanique' },
            'mb': { en: 'Manitoba', fr: 'au Manitoba' },
            'nb': { en: 'New Brunswick', fr: 'au Nouveau-Brunswick' },
            'nl': { en: 'Newfoundland', fr: 'à Terre-Neuve-et-Labrador' },
            'nt': { en: 'North-West Territories', fr: 'à Territoires du nord-ouest' },
            'ns': { en: 'Nova Scotia', fr: 'en Nouvelle-Écosse' },
            'nu': { en: 'Nunavut', fr: 'au Nanavut' },
            'pe': { en: 'Prince Edward Island', fr: "à l'Île-du-Prince-Édouard" },
            'sk': { en: 'Saskatchewan', fr: 'en Saskatchewan' },
            'yt': { en: 'Yukon', fr: 'au Yukon' },
        };
    
        const provinceName = provinceNames[provinceCode];
        return provinceName ? provinceName[isEnglish() ? 'en' : 'fr'] : '';
    }
    
    function getAccessoriesTooltipText() {
        const provinceName = getDisplayableProvinceName();
    
        const text = isEnglish()
            ? `Labour for installation is calculated using average labour rates in ${provinceName}.`
            : `Le coût de la main-d'œuvre pour l'installation est calculé en fonction du tarif horaire moyen ${provinceName}.`;
    
        return text;
    }

    function getTooltipText() {
        const lang = getLang();
        
        return lang === 'en' ? `Labour for installation is calculated using average labour rates in ${getDisplayableProvinceName()}.` : `Le coût de la main-d'œuvre pour l'installation est calculé en fonction du tarif horaire moyen ${getDisplayableProvinceName()}.`;
    }
     /* END HORRIBLE HACK */

    function getLoanDisplayedRate() {
        const financeElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex];
        if (Number.parseFloat(financeElement.aprRate) !== Number.parseFloat(financeElement.aprRateDiscounted))
            return convertNum(financeElement.aprRateDiscounted,2);
        else
            return convertNum(financeElement.aprRate,2);
    }

    function getLeaseDisplayedRate() {
        // `${convertNum(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate,2)}`
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex];
        if (Number.parseFloat(leaseElement.leaseRate) !== Number.parseFloat(leaseElement.leaseRateDiscounted))
            return convertNum(leaseElement.leaseRateDiscounted,2);
        else
            return convertNum(leaseElement.leaseRate,2);
    }

    function getQCEVDisclaimerSection(){
        if(summaryCalculator.IncludeRebates && getProvince() === 'QC' && summaryCalculator.FinancialInfo?.ev_rebates?.length){
             return (
                 <>  
                     <div class="mz-QC-EV-disclaimer text--grey">
                         {ReactHtmlParser(t("general:QCEVDisclaimer"))}
                         
                     </div>
                     
                 </>
             )
        }
     }
     function handleContactDealerLinkClick(e){
        if(e.target.id === 'QCEVD_link' && document.getElementById('contactDealer')){
            e.preventDefault();
            console.log(document.getElementById('contactDealer'))
            document.getElementById('contactDealer').scrollIntoView();
        }
     }


    return (
        <>
        
        <div className="mz-container mz-financial--container">
            <div className="mz-financial--actions mz-financial--actions-alt">
                <div className="actions__wrapper">
					{summaryCalculator.FinancialInfo.calculatedCash.evRebates.details.length > 0 && summaryCalculator.FinancialInfo.calculatedCash.evRebates.details[0].cash && <div className="actions__item">
						<input type="checkbox" value=""  onClick={inclusionCheck} defaultChecked={rebatesChecked} id="rebates" />
						<label htmlFor="rebates"> {t("payments:checkbox_include_government_rebates")}</label>
					</div>}
                    <div className="actions__item">
                        <div className="mz-form-item mz-form-item--checkbox ">
                            <label className="mz-form-item__inner" htmlFor="fees">
                                {t("payments:checkbox_include_fees_and_levies")}
                                <input type="checkbox" className="mz-form-item__checkbox" id="fees" name="fees"  onClick={inclusionCheck} defaultChecked={feesChecked} value="" />
                                {/* <div className="mz-form-item__checkmark">
                                    <div className="mz-svg-wrapper">
                                        <i className="mz-svg mz-svg--black undefined mz-svg-checkmark"></i>
                                    </div>
                                </div> */}
                            </label>
                        </div>
                    </div>

                    <div className="actions__item">
                        <div className="mz-form-item mz-form-item--checkbox ">
                            <label className="mz-form-item__inner" htmlFor="taxes">
                                {t("payments:checkbox_include_taxes_in_prices")}
                                <input type="checkbox" className="mz-form-item__checkbox" id="taxes" name="taxes" onClick={inclusionCheck} defaultChecked={taxesChecked} value=""/>
                                {/* <div className="mz-form-item__checkmark">
                                    <div className="mz-svg-wrapper">
                                        <i className="mz-svg mz-svg--black undefined mz-svg-checkmark"></i>
                                    </div>
                                </div> */}
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <div className="mz-financial--left">
                <div className="mz-financial--finance">
                    <h6>{t("general:finance")}</h6>
                    <p className='mz-financial--finance-terms'>
                        {!summaryCalculator.getResponsesHasError() ?
                        <>
                        <span>{financeTerm} {t("payments:months_lowercase")}</span> <span>{getLoanRate()}</span>
                        </>
                        :
                        <>
                        <p className="text--center">
                            {ReactHtmlParser(t("general:generalErrorMessage"))}
                        </p>
                        </>}
                    </p>

                    {!summaryCalculator.getResponsesHasError() ?
                    <>
                    <div className="periods">
                        <div className="periods--item weekly">
                            <p>{t("payments:weekly")}</p>
                            <span>{getLoanWeekly()}</span> 
                        </div>
                        <div className="periods--item bi-weekly">
                            <p>{t("payments:bi_weekly")}</p>
                            <span>{getLoanBiWeekly()}</span> 
                        </div>
                        <div className="periods--item Monthly">
                            <p>{t("payments:monthly")}</p>
                            <span>{getLoanMonthly()}</span> 
                        </div>
                    </div>
                    </> 
                    : null
                    }       
                    
                    <p>
                        <a className="mz-link" onClick={handleEditFinanceLinkClick}>{t("btn_edit_finance_options")}</a>
                    </p>
                    <div className="mz-financial--cta hidden">
                        {window.allow_oca ? 
                        <Button primary={false} label={ReactHtmlParser(String(t("summary:btn_apply_for_financing")))} iconBefore={false} onClick={()=>financeClick('loan')}/>
                        :
                        summaryCalculator.isSelectionPreOrder() ?
                        <Button primary={true} label={String(t("btn_pre_order"))} iconBefore={false} onClick={handlePreOrderClick}/>
                        :
                        <Button primary={true} label={String(t("btn_reserve_yours"))} iconBefore={false} onClick={()=>{handleReserveYoursClick('Finance')}}/>
                        }
                    </div>
                    {!summaryCalculator.getResponsesHasError() ?
                    <div>
                        <span className='mz-financial--finance-infos'>{getLoanInformationalApr()}&nbsp;{t("text_information_apr")} <Tooltip TooltipName="promo_apr"/></span>
                    </div>:null}
                </div>
                <div className="mz-financial--lease">
                    <h6>{t("payments:lease")}</h6>
                    <p className='mz-financial--finance-terms'>
                        {!summaryCalculator.getResponsesHasError() ?
                        <>
                        <span>{leaseTerm} {t("payments:months_lowercase")}</span> <span>{getLeaseRate()}</span><br/><span>{getAnnualMileageText()}</span>
                        </>
                        :
                        <>
                        <p className="text--center">
                            {ReactHtmlParser(t("general:generalErrorMessage"))}
                        </p>
                        </>}
                    </p>
                    {!summaryCalculator.getResponsesHasError() ?
                    <>
                    <div className="periods">
                        <div className="periods--item weekly">
                            <p>{t("payments:weekly")}</p>
                            <span>{getLeaseWeekly()}</span> 
                        </div>
                        <div className="periods--item bi-weekly">
                            <p>{t("payments:bi_weekly")}</p>
                            <span>{getLeaseBiWeekly()}</span> 
                        </div>
                        <div className="periods--item Monthly">
                            <p>{t("payments:monthly")}</p>
                            <span>{getLeaseMonthly()}</span> 
                        </div>
                    </div>
                    </> 
                    :
                    null}       
                                        

                    <p><a className="mz-link" onClick={handleEditLeaseLinkClick}>{t("btn_edit_lease_options")}</a></p>
                    <div className="mz-financial--cta hidden">
                        {window.allow_oca ? 
                        <Button primary={false} label={ReactHtmlParser(String(t("summary:btn_apply_for_financing")))} iconBefore={false} onClick={()=>financeClick('lease')}/>
                        :
                        summaryCalculator.isSelectionPreOrder() ?
                        <Button primary={true} label={String(t("btn_pre_order"))} iconBefore={false} onClick={handlePreOrderClick}/>
                        :                        
                        <Button primary={true} label={String(t("btn_reserve_yours"))} iconBefore={false} onClick={()=>{handleReserveYoursClick('Lease')}}/>}
                    </div>
                    {!summaryCalculator.getResponsesHasError() ?
					<div>
                        <span className='mz-financial--finance-infos'>{getLeaseInformationalApr()}&nbsp;{t("text_information_apr")} <Tooltip TooltipName="promo_apr"/></span>
                    </div>:null}
                </div>
            </div>
            <div className="mz-financial--right">
                <h6>{t("payments:cash_purchase_price")}</h6>
                <div>{t("purchase_price")}  <Tooltip TooltipName="purchase_price" /></div>
                {selectedBox === 'feesCheck' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFees, true)}</span>}
                {selectedBox === 'taxesCheck' &&<span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalTaxed, true)}</span>}
                {selectedBox === 'rebatesCheck' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebates, true)}</span>}
                {selectedBox === 'feestaxes' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesTaxed, true)}</span>}
                {selectedBox === 'feesrebates' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesWithRebatesAndEvRebates, true)}</span>}
                {selectedBox === 'taxesrebates' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxed, true)}</span>}
                {selectedBox === 'allCheck' && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxed, true)}</span>}
                {selectedBox === null && <span className='mz-detailed-price__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotal, true)}</span>}
                <div className="mz-financial--details">


                    {/* {financialInfo?.calculatedCash ? <CashOptions financialInfo={financialInfo} includeFees={selectedBox} includeTaxes={selectedBox} includeRebates={selectedBox}  /> : null} */}

                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={`${t('payments:cash_price')}`} ColBoxText={getMazdaPriceDetails()} ColClassPrice="mz-collapse__price" TooltipName="detailedprice_mazdaprice" ColPrices={`${formatPrice(getMazdaPrice(), true)}`} isOpen={openCollapsable === 'mzPrice'} setOpenCollapsable={setOpenCollapsable} id={String(Math.floor(Math.random() * 100000000))}/>

                    {summaryCalculator.FinancialInfo ?.calculatedFinance ?.options.wheels.title ? 
                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("payments:cash_option_wheels")} ColBoxText={getWheelsDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  TooltipText={ReactHtmlParser(getTooltipText())} ColPrices={`${formatPrice(getWheelsPrice(), true)}`} id={String(Math.floor(Math.random() * 100000000))} />
                    : null}

                    {summaryCalculator.SelectedConnectedVehiclePackage.financial.msrp ?
                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("payments:cash_option_connectivity")} ColBoxText={getConnectivityDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  ColPrices={`${formatPrice(getConnectivityPrice(), true)}`} id={String(Math.floor(Math.random() * 100000000))} />
                    : null }

                    {summaryCalculator.FinancialInfo ?.calculatedFinance ?.accessories.total ? 
                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("payments:cash_option_accessories")} ColBoxText={getAccessoriesDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  TooltipText={getAccessoriesTooltipText()} ColPrices={`${formatPrice(getAccessoriesPrice(), true)}`} id={String(Math.floor(Math.random() * 100000000))} />
                    : null }

                    {summaryCalculator.SelectedAddedProtectionPackage.name || summaryCalculator.SelectedAppearanceProtectionPlansIndex !== null?  
                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("payments:cash_option_protection")} ColBoxText={getProtectionDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  ColPrices={`${formatPrice(getProtectionPrice(), true)}`} id={String(Math.floor(Math.random() * 100000000))} />
                    : null }                


                    {feesChecked ?< CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={`${t('payments:cash_fees')}`} ColBoxText={getMazdaFeesAndLeviesDetails()} ColClassPrice="mz-collapse__price" TooltipName="detailedprice_feesandlevies"  ColPrices={`${formatPrice(getMazdaFeesAndLeviesPricingWithoutPDE(), true)}`} isOpen={openCollapsable === 'mzFees'} setOpenCollapsable={setOpenCollapsable} id={String(Math.floor(Math.random() * 100000000))}/>:null}
                    {taxesChecked ? <div className="mz-financial__non-collapse"><p className="mz-financial__non-collapse__title">{t("payments:taxes")} <Tooltip TooltipName="detailedprice_taxes" /></p>
                        {selectedBox === 'feesCheck' && <span className="mz-financial__non-collapse__price">{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesTaxes, true)}</span>}
                        {selectedBox === 'taxesCheck' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalTaxes, true)}</span>}
                        {selectedBox === 'rebatesCheck' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxes, true)}</span>}
                        {selectedBox === 'feestaxes' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesTaxes, true)}</span>}
                        {selectedBox === 'feesrebates' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxes, true)}</span>}
                        {selectedBox === 'taxesrebates' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxes, true)}</span>}
                        {selectedBox === 'allCheck' && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxes, true)}</span>}
                        {selectedBox === null && <span className='mz-financial__non-collapse__price'>{formatPrice(summaryCalculator.FinancialInfo.calculatedCash.subtotal, true)}</span>}
                    </div>:null}

                    < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price negative" ColCarText1={`${t('payments:cash_credits')}`} ColBoxText={getCreditsDetails()} ColClassPrice="mz-collapse__price" TooltipName="detailedprice_credit" ColPrices={`${currentIncentives.value + summaryCalculator.FinancialInfo.calculatedCash.incentives.taxable.total + summaryCalculator.FinancialInfo.calculatedCash.incentives.nonTaxable.total + Obj.tradeInValue + summaryCalculator.FinancialInfo.mazdaCashIncentive >0?'-':''}${formatPrice(currentIncentives.value + summaryCalculator.FinancialInfo.calculatedCash.incentives.taxable.total + summaryCalculator.FinancialInfo.calculatedCash.incentives.nonTaxable.total + summaryCalculator.FinancialInfo.tradeInValue + summaryCalculator.FinancialInfo.mazdaCashIncentive, true)}`} isOpen={openCollapsable === 'mzCredits'} setOpenCollapsable={setOpenCollapsable} id={String(Math.floor(Math.random() * 100000000))}/>
                    <div className="mz-financial__non-collapse negative">
                        <div className="mz-financial__non-collapse__title">{t("payments:down_payment")}<sup>1</sup> <Tooltip TooltipName="detailedprice_downpayment" /></div>
                        <span className="mz-financial__non-collapse__price">{formatPrice(Obj.downPaymentValue, true)}</span>
                    </div>
                    {selectedBox === 'rebatesCheck' || selectedBox === 'taxesrebates' || selectedBox === 'allCheck' || selectedBox === 'feesrebates'  && summaryCalculator.FinancialInfo?.ev_rebates?.length ?< CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price evRebates" ColCarText1={t("payments:gov_rebates")} ColBoxText={getRebatesDetails()} ColClassPrice="mz-collapse__price" ColPrices={`${summaryCalculator.FinancialInfo.calculatedCash.evRebates.total.cash>0?'-':''}${formatPrice(summaryCalculator.FinancialInfo.calculatedCash.evRebates.total.cash, true)}`} isOpen={openCollapsable === 'mzRebates'} setOpenCollapsable={setOpenCollapsable}/>:null}
                </div>
				<div className="mz-financial--cta">
                    {summaryCalculator.isSelectionPreOrder() ?
                    <Button primary={true} label={String(t("btn_pre_order"))} iconBefore={false} onClick={handlePreOrderClick}/>
                    :                    
	                <Button primary={true} label={String(t("btn_reserve_yours"))} iconBefore={false} onClick={()=>{handleReserveYoursClick('Cash')}}/>
                    }
	            </div>
            </div>
            <ReserveModal isOpen={reserveOpen} handleClose={setReserveModalOpen}></ReserveModal> 
            <OcaModal isOpen={ocaOpen} financeType={financeType} handleClose={setOcaModalOpen}></OcaModal>                       
        </div>
        <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
        </>
    );
};
